import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGlobe, FiNavigation } = FiIcons;

const Header = () => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="relative z-10 pt-8 pb-4"
    >
      <div className="container mx-auto px-4 text-center">
        <motion.div
          className="flex items-center justify-center gap-3 mb-4"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <div className="relative">
            <SafeIcon icon={FiGlobe} className="text-5xl text-blue-400" />
            <motion.div
              className="absolute inset-0"
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            >
              <SafeIcon icon={FiNavigation} className="text-2xl text-green-400 absolute top-2 left-2" />
            </motion.div>
          </div>
        </motion.div>
        <motion.h1 style={{
      fontSize: '60px'
    }} 
          className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-green-400 bg-clip-text text-transparent mb-4 leading-tight"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >Dig to China</motion.h1>
        <motion.p
          className="text-xl md:text-2xl text-slate-300 max-w-4xl mx-auto leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Enter any address and discover what's on the{' '}
          <span className="text-blue-400 font-semibold">exact opposite side</span>{' '}
          of our planet
        </motion.p>
      </div>
    </motion.header>
  );
};

export default Header;